module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAUCAYAAACaq43EAAABDElEQVR42r3SMUvDQBjG8fsY3cRPUAehIFic/QTi1KmCWwjiolRClIJgl056kOAQgtxRKKSgBecQih8iQhaHikIyhPAIWV6QLife+8B/ueUHLye2bk7QvxfsCeG+gXBmmHB+mHB+mHB+mHBumNqbPhTe6/HKVgRvaPRc4Pe+v9ZYqBF0dI3Z0y0W+gqf6w+YroVN8KZpsFy+wJMeBpMBZnOFuq7/BpviOtE4ONvH7vkOpJagWYTzPEeWZYgfJeSdjzRN2zfrpw6CAHEcY+xd4sI5RRRFCMPQGDb+XFVVQSkF3/fbkiRBWZb/Bw+PxkXR665stRF2Dl28b3esJthRgvlRggllhAnlhQnl7Qfpdatjo7p3zwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/gq.png
// module id = 833
// module chunks = 0